import { Info } from "lucide-react";

interface InfoCalloutProps {
  description: string;
  title: string;
}

export function InfoCallout({ description, title }: InfoCalloutProps) {
  return (
    <div
      className="
      w-full
      rounded-2xl
      border
      border-border-secondary
      bg-bg-primary_alt
      p-5
      flex
      gap-4
      items-start
    "
    >
      <div
        className="
        flex-shrink-0
        w-12 h-12
        rounded-full
        bg-bg-brand-primary
        flex
        items-center
        justify-center
      "
      >
        <Info className="w-6 h-6 text-text-brand-secondary" />
      </div>

      <div className="flex flex-col gap-1">
        <h3 className="text-base font-semibold text-text-primary">{title}</h3>

        <p className="text-sm text-text-secondary leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
}
